import { DialogObject } from '@/components/dialog/dialog.types';

interface IDeleteSeuilDialogObjectProps {
  action: () => void;
  toggleVisibility: () => void;
}

export const getDeleteSeuilDialogObject = ({ action, toggleVisibility }: IDeleteSeuilDialogObjectProps): DialogObject => {
  return {
    title: 'settings.seuils.dialog.delete.title',
    description: 'settings.seuils.dialog.delete.description',
    actions: [
      {
        label: 'common.delete.confirm',
        onClick: () => action(),
        variant: 'danger',
      },
      {
        label: 'common.delete.cancel',
        onClick: () => toggleVisibility(),
        variant: 'secondary',
      },
    ],
  };
};
